module.exports = __webpack_public_path__ + "static/solution-sustenance-f16172337be72784a7db9de4f53d7446.png";